import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ViewType } from "@/classes/data-structures/view-type";
import { useAppStateStore } from "@/store/app-state";


export default /*#__PURE__*/_defineComponent({
  __name: 'MapButton',
  setup(__props) {

let state = useAppStateStore();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["map-button", { hidden: _unref(state).viewType == _unref(ViewType).View3D || !_unref(state).canChangeMapType, satelite: _unref(state).mapType !== 'satellite' }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).setMapType(_unref(state).mapType === 'satellite' ? 'vector' : 'satellite')))
  }, null, 2))
}
}

})